import styled from 'styled-components';
import { BasketSelectSectionStyled } from '../BasketFinancePaymentSelectionStyled';
import { rem } from 'polished';

export const BasketFinancePaymentSelectionAP = styled(BasketSelectSectionStyled)`
    .section {
        .description {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
        }

        .summary {
            .totalLabel {
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                padding-bottom: ${rem(15)};
            }

            .otherPrices {
                .otherPrice {
                    font-size: ${({ theme }) => theme.fontSizes.textBase};
                }
            }
        }
    }
`;
